import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit'
import { notificationController } from '@app/controllers/notification-controller'
import { t } from 'i18next'
import { readToken } from '@app/store/services/local-storage.service'

export const errorLoggingMiddleware: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const token = readToken()

    if (!token) return next(action)

    const translatedMessage = t(action.payload) || t('common.genericError')
    notificationController.error({ message: translatedMessage })
  }

  return next(action)
}
